function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The Timeline plugin adds timestamps and notches under the waveform.
 */
import BasePlugin from '../base-plugin.js';
var defaultOptions = {
  height: 20,
  formatTimeCallback: function formatTimeCallback(seconds) {
    if (seconds / 60 > 1) {
      // calculate minutes and seconds from seconds count
      var minutes = Math.floor(seconds / 60);
      seconds = Math.round(seconds % 60);
      var paddedSeconds = "".concat(seconds < 10 ? '0' : '').concat(seconds);
      return "".concat(minutes, ":").concat(paddedSeconds);
    }

    var rounded = Math.round(seconds * 1000) / 1000;
    return "".concat(rounded);
  }
};

var TimelinePlugin = /*#__PURE__*/function (_BasePlugin) {
  _inherits(TimelinePlugin, _BasePlugin);

  var _super = _createSuper(TimelinePlugin);

  function TimelinePlugin(options) {
    var _this;

    _classCallCheck(this, TimelinePlugin);

    _this = _super.call(this, options || {});
    _this.options = Object.assign({}, defaultOptions, options);
    _this.timelineWrapper = _this.initTimelineWrapper();
    return _this;
  }

  _createClass(TimelinePlugin, [{
    key: "onInit",
    value:
    /** Called by wavesurfer, don't call manually */
    function onInit() {
      var _this2 = this;

      var _a;

      if (!this.wavesurfer) {
        throw Error('WaveSurfer is not initialized');
      }

      var container = (_a = this.options.container) !== null && _a !== void 0 ? _a : this.wavesurfer.getWrapper();

      if (this.options.insertPosition) {
        ;
        (container.firstElementChild || container).insertAdjacentElement(this.options.insertPosition, this.timelineWrapper);
      } else {
        container.appendChild(this.timelineWrapper);
      }

      if (this.options.duration) {
        this.initTimeline(this.options.duration);
      } else {
        this.subscriptions.push(this.wavesurfer.on('redraw', function () {
          var _a;

          _this2.initTimeline(((_a = _this2.wavesurfer) === null || _a === void 0 ? void 0 : _a.getDuration()) || 0);
        }));
      }
    }
    /** Unmount */

  }, {
    key: "destroy",
    value: function destroy() {
      this.timelineWrapper.remove();

      _get(_getPrototypeOf(TimelinePlugin.prototype), "destroy", this).call(this);
    }
  }, {
    key: "initTimelineWrapper",
    value: function initTimelineWrapper() {
      var div = document.createElement('div');
      div.setAttribute('part', 'timeline');
      return div;
    } // Return how many seconds should be between each notch

  }, {
    key: "defaultTimeInterval",
    value: function defaultTimeInterval(pxPerSec) {
      if (pxPerSec >= 25) {
        return 1;
      } else if (pxPerSec * 5 >= 25) {
        return 5;
      } else if (pxPerSec * 15 >= 25) {
        return 15;
      }

      return Math.ceil(0.5 / pxPerSec) * 60;
    } // Return the cadence of notches that get labels in the primary color.

  }, {
    key: "defaultPrimaryLabelInterval",
    value: function defaultPrimaryLabelInterval(pxPerSec) {
      if (pxPerSec >= 25) {
        return 10;
      } else if (pxPerSec * 5 >= 25) {
        return 6;
      } else if (pxPerSec * 15 >= 25) {
        return 4;
      }

      return 4;
    } // Return the cadence of notches that get labels in the secondary color.

  }, {
    key: "defaultSecondaryLabelInterval",
    value: function defaultSecondaryLabelInterval(pxPerSec) {
      if (pxPerSec >= 25) {
        return 5;
      } else if (pxPerSec * 5 >= 25) {
        return 2;
      } else if (pxPerSec * 15 >= 25) {
        return 2;
      }

      return 2;
    }
  }, {
    key: "initTimeline",
    value: function initTimeline(duration) {
      var _a, _b, _c;

      var pxPerSec = this.timelineWrapper.scrollWidth / duration;
      var timeInterval = (_a = this.options.timeInterval) !== null && _a !== void 0 ? _a : this.defaultTimeInterval(pxPerSec);
      var primaryLabelInterval = (_b = this.options.primaryLabelInterval) !== null && _b !== void 0 ? _b : this.defaultPrimaryLabelInterval(pxPerSec);
      var secondaryLabelInterval = (_c = this.options.secondaryLabelInterval) !== null && _c !== void 0 ? _c : this.defaultSecondaryLabelInterval(pxPerSec);
      var isTop = this.options.insertPosition === 'beforebegin';
      var timeline = document.createElement('div');
      timeline.setAttribute('style', "\n      height: ".concat(this.options.height, "px;\n      overflow: hidden;\n      font-size: ").concat(this.options.height / 2, "px;\n      white-space: nowrap;\n      position: relative;\n    "));

      if (isTop) {
        var topStyle = "\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        z-index: 2;\n      ";
        timeline.setAttribute('style', timeline.getAttribute('style') + topStyle);
      }

      if (typeof this.options.style === 'string') {
        timeline.setAttribute('style', timeline.getAttribute('style') + this.options.style);
      } else if (_typeof(this.options.style) === 'object') {
        Object.assign(timeline.style, this.options.style);
      }

      var notchEl = document.createElement('div');
      notchEl.setAttribute('part', 'timeline-notch');
      notchEl.setAttribute('style', "\n      width: 0;\n      height: 50%;\n      display: flex;\n      flex-direction: column;\n      justify-content: ".concat(isTop ? 'flex-start' : 'flex-end', ";\n      ").concat(isTop ? 'top: 0;' : 'bottom: 0;', "\n      overflow: visible;\n      border-left: 1px solid currentColor;\n      opacity: 0.25;\n      position: absolute;\n      z-index: 1;\n    "));

      for (var i = 0; i < duration; i += timeInterval) {
        var notch = notchEl.cloneNode();
        var isPrimary = Math.round(i * 100) / 100 % primaryLabelInterval === 0;
        var isSecondary = Math.round(i * 100) / 100 % secondaryLabelInterval === 0;

        if (isPrimary || isSecondary) {
          notch.style.height = '100%';
          notch.style.textIndent = '3px';
          notch.textContent = this.options.formatTimeCallback(i);
          if (isPrimary) notch.style.opacity = '1';
        }

        notch.style.left = "".concat(i * pxPerSec, "px");
        timeline.appendChild(notch);
      }

      this.timelineWrapper.innerHTML = '';
      this.timelineWrapper.appendChild(timeline);
      this.emit('ready');
    }
  }], [{
    key: "create",
    value: function create(options) {
      return new TimelinePlugin(options);
    }
  }]);

  return TimelinePlugin;
}(BasePlugin);

export default TimelinePlugin;